import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/chat")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="relative h-full bg-gray-light flex flex-col">
			<Outlet />
		</div>
	);
}
